import { CLEAR_ERRORS } from "../Constants/LoginConstants";
import {
  CLEAR_INVENTORY_DETAILS,
  CLOSE_BOX_FAILURE,
  CLOSE_BOX_REQUEST,
  CLOSE_BOX_SUCCESS,
  CREATE_BOX_FAILURE,
  CREATE_BOX_REQUEST,
  CREATE_BOX_SUCCESS,
  CREATE_MRP_LABEL_FAILURE,
  CREATE_MRP_LABEL_REQUEST,
  CREATE_MRP_LABEL_SUCCESS,
  DEACTIVATE_HOLD_FAILURE,
  DEACTIVATE_HOLD_REQUEST,
  DEACTIVATE_HOLD_SUCCESS,
  DOWNLOAD_BOX_LABEL_FAILURE,
  DOWNLOAD_BOX_LABEL_REQUEST,
  DOWNLOAD_BOX_LABEL_SUCCESS,
  GET_BATCH_DETAILS_FAILURE,
  GET_BATCH_DETAILS_REQUEST,
  GET_BATCH_DETAILS_SUCCESS,
  GET_BATCHES_FAILURE,
  GET_BATCHES_REQUEST,
  GET_BATCHES_SUCCESS,
  GET_BOX_SETTING_FAILURE,
  GET_BOX_SETTING_REQUEST,
  GET_BOX_SETTING_SUCCESS,
  GET_BOX_TYPE_FAILURE,
  GET_BOX_TYPE_REQUEST,
  GET_BOX_TYPE_SUCCESS,
  GET_FROM_LOCATION_DROPDOWN_LIST_FAILURE,
  GET_FROM_LOCATION_DROPDOWN_LIST_REQUEST,
  GET_FROM_LOCATION_DROPDOWN_LIST_SUCCESS,
  GET_INVENTORY_DETAILS_FAILURE,
  GET_INVENTORY_DETAILS_REQUEST,
  GET_INVENTORY_DETAILS_SUCCESS,
  GET_INVOICE_LIST_FAILURE,
  GET_INVOICE_LIST_REQUEST,
  GET_INVOICE_LIST_SUCCESS,
  GET_MISSING_INVENTORY_LIST_FAILURE,
  GET_MISSING_INVENTORY_LIST_REQUEST,
  GET_MISSING_INVENTORY_LIST_SUCCESS,
  GET_PARTY_LIST_FAILURE,
  GET_PARTY_LIST_REQUEST,
  GET_PARTY_LIST_SUCCESS,
  GET_PORTAL_NET_INVENTORY_FAILURE,
  GET_PORTAL_NET_INVENTORY_REQUEST,
  GET_PORTAL_NET_INVENTORY_SUCCESS,
  GET_PRODUCTS_LIST_FAILURE,
  GET_PRODUCTS_LIST_REQUEST,
  GET_PRODUCTS_LIST_SUCCESS,
  GET_SALES_ANALYSIS_LIST_FAILURE,
  GET_SALES_ANALYSIS_LIST_REQUEST,
  GET_SALES_ANALYSIS_LIST_SUCCESS,
  GET_SKU_PRODUCTS_FAILURE,
  GET_SKU_PRODUCTS_REQUEST,
  GET_SKU_PRODUCTS_SUCCESS,
  GET_SUB_ORDER_SUMMARY_FAILURE,
  GET_SUB_ORDER_SUMMARY_REQUEST,
  GET_SUB_ORDER_SUMMARY_SUCCESS,
  GET_SUBLOCATION_LIST_FAILURE,
  GET_SUBLOCATION_LIST_REQUEST,
  GET_SUBLOCATION_LIST_SUCCESS,
  GET_TEMP_HOLD_SUMMARY_FAILURE,
  GET_TEMP_HOLD_SUMMARY_REQUEST,
  GET_TEMP_HOLD_SUMMARY_SUCCESS,
  GET_TO_LOCATION_DROPDOWN_LIST_FAILURE,
  GET_TO_LOCATION_DROPDOWN_LIST_REQUEST,
  GET_TO_LOCATION_DROPDOWN_LIST_SUCCESS,
  GET_USER_PROFILE_FAILURE,
  GET_USER_PROFILE_REQUEST,
  GET_USER_PROFILE_SUCCESS,
  HOURLY_PRODUCTION__REPORT_FAILURE,
  HOURLY_PRODUCTION__REPORT_REQUEST,
  HOURLY_PRODUCTION__REPORT_SUCCESS,
  MARK_HOLD_FAILURE,
  MARK_HOLD_REQUEST,
  MARK_HOLD_SUCCESS,
  PORTAL_NET_INVENTORY_POPUP_FAILURE,
  PORTAL_NET_INVENTORY_POPUP_REQUEST,
  PORTAL_NET_INVENTORY_POPUP_SUCCESS,
  PRODUCT_SUB_GROUP_MASTER_DATA_FAILURE,
  PRODUCT_SUB_GROUP_MASTER_DATA_REQUEST,
  PRODUCT_SUB_GROUP_MASTER_DATA_SUCCESS,
  PRODUCT_WISE_CONSOLIDATED_REPORT_FAILURE,
  PRODUCT_WISE_CONSOLIDATED_REPORT_REQUEST,
  PRODUCT_WISE_CONSOLIDATED_REPORT_SUCCESS,
  SALES_ANALYSIS_DETAILS_FAILURE,
  SALES_ANALYSIS_DETAILS_REQUEST,
  SALES_ANALYSIS_DETAILS_SUCCESS,
  SAVE_BOX_SETTING_FAILURE,
  SAVE_BOX_SETTING_REQUEST,
  SAVE_BOX_SETTING_SUCCESS,
  SAVE_BOX_TYPE_FAILURE,
  SAVE_BOX_TYPE_REQUEST,
  SAVE_BOX_TYPE_SUCCESS,
  SAVE_TEMP_HOLD_INVENTORY_FAILURE,
  SAVE_TEMP_HOLD_INVENTORY_REQUEST,
  SAVE_TEMP_HOLD_INVENTORY_SUCCESS,
  SCAN_SERIAL_BOX_INVENTORY_FAILURE,
  SCAN_SERIAL_BOX_INVENTORY_REQUEST,
  SCAN_SERIAL_BOX_INVENTORY_SUCCESS,
  SUBORDER_LEVEL_VIEW_CONSOLIDATE_FAILURE,
  SUBORDER_LEVEL_VIEW_CONSOLIDATE_REQUEST,
  SUBORDER_LEVEL_VIEW_CONSOLIDATE_SUCCESS,
  SYNC_CRON_FUNCTION_FAILURE,
  SYNC_CRON_FUNCTION_REQUEST,
  SYNC_CRON_FUNCTION_SUCCESS,
  UNDO_SCANNABLE_INCOMING_FAILURE,
  UNDO_SCANNABLE_INCOMING_REQUEST,
  UNDO_SCANNABLE_INCOMING_SUCCESS,
  VIEW_PREVIOUS_BOX_FAILURE,
  VIEW_PREVIOUS_BOX_REQUEST,
  VIEW_PREVIOUS_BOX_SUCCESS,
} from "../Constants/ProductionConstants";

// Manufacturing Dropdown Data List Reducers
export const ManufacturingPackingDropdownDataReducers = (
  state = {
    from_location: {},
    to_location: {},
    invoice_list: {},
    party_list: {},
    sub_location: {},
  },
  action
) => {
  switch (action.type) {
    case GET_FROM_LOCATION_DROPDOWN_LIST_REQUEST:
    case GET_TO_LOCATION_DROPDOWN_LIST_REQUEST:
    case GET_INVOICE_LIST_REQUEST:
    case GET_PARTY_LIST_REQUEST:
    case GET_SUBLOCATION_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_FROM_LOCATION_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        from_location: action.payload,
      };
    case GET_TO_LOCATION_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        to_location: action.payload,
      };
    case GET_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        invoice_list: action.payload,
      };
    case GET_PARTY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        party_list: action.payload,
      };
    case GET_SUBLOCATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        sub_location: action.payload,
      };
    case GET_FROM_LOCATION_DROPDOWN_LIST_FAILURE:
    case GET_TO_LOCATION_DROPDOWN_LIST_FAILURE:
    case GET_INVOICE_LIST_FAILURE:
    case GET_PARTY_LIST_FAILURE:
    case GET_SUBLOCATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Inventory Details Reducers
export const getInventoryDetailsReducers = (
  state = { inventory_details: {} },
  action
) => {
  switch (action.type) {
    case GET_INVENTORY_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case GET_INVENTORY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        inventory_details: action.payload,
      };
    case GET_INVENTORY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    case CLEAR_INVENTORY_DETAILS:
      return {
        ...state,
        inventory_details: {},
      };
    default:
      return state;
  }
};

// Get Table List/Product List Reducers
export const getProductListReducers = (
  state = { products_list: {} },
  action
) => {
  switch (action.type) {
    case GET_PRODUCTS_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_PRODUCTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        products_list: action.payload,
      };
    case GET_PRODUCTS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// View Previous Box Reducers
export const viewPreviousBoxReducers = (
  state = { previous_box: {} },
  action
) => {
  switch (action.type) {
    case VIEW_PREVIOUS_BOX_REQUEST:
      return {
        loading: true,
      };
    case VIEW_PREVIOUS_BOX_SUCCESS:
      return {
        ...state,
        loading: false,
        previous_box: action.payload,
      };
    case VIEW_PREVIOUS_BOX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Scan Serial Box Reducers
export const scanSerialBoxReducers = (
  state = { scan_serial_box: {} },
  action
) => {
  switch (action.type) {
    case SCAN_SERIAL_BOX_INVENTORY_REQUEST:
      return {
        loading: true,
      };
    case SCAN_SERIAL_BOX_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        scan_serial_box: action.payload,
      };
    case SCAN_SERIAL_BOX_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Create MRP Label Reducers
export const createMRPLabelReducers = (state = { mrp_label: {} }, action) => {
  switch (action.type) {
    case CREATE_MRP_LABEL_REQUEST:
      return {
        loading: true,
      };
    case CREATE_MRP_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        mrp_label: action.payload,
      };
    case CREATE_MRP_LABEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Close Box Reducers
export const closeBoxReducers = (state = { close_box: {} }, action) => {
  switch (action.type) {
    case CLOSE_BOX_REQUEST:
      return {
        loading: true,
      };
    case CLOSE_BOX_SUCCESS:
      return {
        ...state,
        loading: false,
        close_box: action.payload,
      };
    case CLOSE_BOX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Create Box Reducers
export const createBoxReducers = (state = { create_Box: {} }, action) => {
  switch (action.type) {
    case CREATE_BOX_REQUEST:
      return {
        loading: true,
      };
    case CREATE_BOX_SUCCESS:
      return {
        ...state,
        loading: false,
        create_Box: action.payload,
      };
    case CREATE_BOX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Download Box Label Reducers
export const DownloadBoxLabelReducers = (state = { box_label: {} }, action) => {
  switch (action.type) {
    case DOWNLOAD_BOX_LABEL_REQUEST:
      return {
        loading: true,
      };
    case DOWNLOAD_BOX_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        box_label: action.payload,
      };
    case DOWNLOAD_BOX_LABEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get SKU Products Reducers
export const GetSkuProductsReducers = (
  state = { SKU_products: {} },
  action
) => {
  switch (action.type) {
    case GET_SKU_PRODUCTS_REQUEST:
      return {
        loading: true,
      };
    case GET_SKU_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        SKU_products: action.payload,
      };
    case GET_SKU_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get User Profile Reducers
export const GetUserProfileReducers = (
  state = { user_profile: {} },
  action
) => {
  switch (action.type) {
    case GET_USER_PROFILE_REQUEST:
      return {
        loading: true,
      };
    case GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        user_profile: action.payload,
      };
    case GET_USER_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// ************************************  NEW CODE ********************************************8
// Save Get Box Type Reducers
export const SaveGetBoxTypeReducers = (
  state = { BoxType: {}, saveBoxType: {} },
  action
) => {
  switch (action.type) {
    case SAVE_BOX_TYPE_REQUEST:
    case GET_BOX_TYPE_REQUEST:
      return {
        loading: true,
      };
    case SAVE_BOX_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        saveBoxType: action.payload,
      };
    case GET_BOX_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        BoxType: action.payload,
      };
    case SAVE_BOX_TYPE_FAILURE:
    case GET_BOX_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Save Get Box Setting Reducers
export const SaveGetBoxSettingsReducers = (
  state = { BoxSetting: {}, saveBoxSetting: {} },
  action
) => {
  switch (action.type) {
    case SAVE_BOX_SETTING_REQUEST:
    case GET_BOX_SETTING_REQUEST:
      return {
        loading: true,
      };
    case SAVE_BOX_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        saveBoxSetting: action.payload,
      };
    case GET_BOX_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        BoxSetting: action.payload,
      };
    case SAVE_BOX_SETTING_FAILURE:
    case GET_BOX_SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Product Sub Group Master Data Reducers
export const ProductSubGroupMasterDataReducers = (
  state = { productSubGroupMasterData: {} },
  action
) => {
  switch (action.type) {
    case PRODUCT_SUB_GROUP_MASTER_DATA_REQUEST:
      return {
        loading: true,
      };
    case PRODUCT_SUB_GROUP_MASTER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        productSubGroupMasterData: action.payload,
      };
    case PRODUCT_SUB_GROUP_MASTER_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Undo scannable Incoming Reducers
export const undoScannableIncomingReducers = (
  state = { scannableIncoming: {} },
  action
) => {
  switch (action.type) {
    case UNDO_SCANNABLE_INCOMING_REQUEST:
      return {
        loading: true,
      };
    case UNDO_SCANNABLE_INCOMING_SUCCESS:
      return {
        ...state,
        loading: false,
        scannableIncoming: action.payload,
      };
    case UNDO_SCANNABLE_INCOMING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Batches Reducers
export const getBatchesReducers = (state = { getBatches: {} }, action) => {
  switch (action.type) {
    case GET_BATCHES_REQUEST:
      return {
        loading: true,
      };
    case GET_BATCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        getBatches: action.payload,
      };
    case GET_BATCHES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Batch Details Reducers
export const getBatchDetailsReducers = (
  state = { batchDetails: {} },
  action
) => {
  switch (action.type) {
    case GET_BATCH_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case GET_BATCH_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        batchDetails: action.payload,
      };
    case GET_BATCH_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Mark Hold Reducers
export const MarkHoldReducers = (state = { markHold: {} }, action) => {
  switch (action.type) {
    case MARK_HOLD_REQUEST:
      return {
        loading: true,
      };
    case MARK_HOLD_SUCCESS:
      return {
        ...state,
        loading: false,
        markHold: action.payload,
      };
    case MARK_HOLD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Product Level Consolidated Report Reducers
export const ProductLevelConsolidatedReportReducers = (
  state = { productLevelConsolidated_Report: {} },
  action
) => {
  switch (action.type) {
    case PRODUCT_WISE_CONSOLIDATED_REPORT_REQUEST:
      return {
        loading: true,
      };
    case PRODUCT_WISE_CONSOLIDATED_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        productLevelConsolidated_Report: action.payload,
      };
    case PRODUCT_WISE_CONSOLIDATED_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Hourly Production Report Reducers
export const HourlyProductionReportReducers = (
  state = { hourlyProductionRep: {} },
  action
) => {
  switch (action.type) {
    case HOURLY_PRODUCTION__REPORT_REQUEST:
      return {
        loading: true,
      };
    case HOURLY_PRODUCTION__REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        hourlyProductionRep: action.payload,
      };
    case HOURLY_PRODUCTION__REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Sub order Summary Reducers
export const getSubOrderSummaryReducers = (
  state = { suborder_summary: {} },
  action
) => {
  switch (action.type) {
    case GET_SUB_ORDER_SUMMARY_REQUEST:
      return {
        loading: true,
      };
    case GET_SUB_ORDER_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        suborder_summary: action.payload,
      };
    case GET_SUB_ORDER_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Save Temp Hold Reducers
export const saveTempHoldReducers = (
  state = { saveTempHold: {}, getTempHoldSummary: {} },
  action
) => {
  switch (action.type) {
    case SAVE_TEMP_HOLD_INVENTORY_REQUEST:
    case GET_TEMP_HOLD_SUMMARY_REQUEST:
      return {
        loading: true,
      };
    case SAVE_TEMP_HOLD_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        saveTempHold: action.payload,
      };
    case GET_TEMP_HOLD_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        getTempHoldSummary: action.payload,
      };
    case SAVE_TEMP_HOLD_INVENTORY_FAILURE:
    case GET_TEMP_HOLD_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Deactivate Hold Reducers
export const DeactivateHoldReducers = (state = { holdTemp: {} }, action) => {
  switch (action.type) {
    case DEACTIVATE_HOLD_REQUEST:
      return {
        loading: true,
      };
    case DEACTIVATE_HOLD_SUCCESS:
      return {
        ...state,
        loading: false,
        holdTemp: action.payload,
      };
    case DEACTIVATE_HOLD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Portal Net Inventory Reducers
export const getPortalNetInventoryReducers = (
  state = { portalAvailNetInvent: {} },
  action
) => {
  switch (action.type) {
    case GET_PORTAL_NET_INVENTORY_REQUEST:
      return {
        loading: true,
      };
    case GET_PORTAL_NET_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        portalAvailNetInvent: action.payload,
      };
    case GET_PORTAL_NET_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Sub Order Level View Reducers
export const getSubOrderLevelViewReducers = (
  state = { subOrderLevelView: {} },
  action
) => {
  switch (action.type) {
    case SUBORDER_LEVEL_VIEW_CONSOLIDATE_REQUEST:
      return {
        loading: true,
      };
    case SUBORDER_LEVEL_VIEW_CONSOLIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        subOrderLevelView: action.payload,
      };
    case SUBORDER_LEVEL_VIEW_CONSOLIDATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Sales Analysis List Reducers
export const getSalesAnalysisListReducers = (
  state = { sales__analysisList: {} },
  action
) => {
  switch (action.type) {
    case GET_SALES_ANALYSIS_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_SALES_ANALYSIS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        sales__analysisList: action.payload,
      };
    case GET_SALES_ANALYSIS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Sales Analysis Details Reducers
export const getSalesAnalysisDetailsReducers = (
  state = { sales__analysisDetails: {} },
  action
) => {
  switch (action.type) {
    case SALES_ANALYSIS_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case SALES_ANALYSIS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        sales__analysisDetails: action.payload,
      };
    case SALES_ANALYSIS_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Missing Inventory List Reducers
export const getMissingInventoryListReducers = (
  state = { missingInventoryList: {} },
  action
) => {
  switch (action.type) {
    case GET_MISSING_INVENTORY_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_MISSING_INVENTORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        missingInventoryList: action.payload,
      };
    case GET_MISSING_INVENTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Portal Net Inventory Popup Reducers
export const PortalNetInventoryPopupReducers = (
  state = { portalNetInventPopup: {} },
  action
) => {
  switch (action.type) {
    case PORTAL_NET_INVENTORY_POPUP_REQUEST:
      return {
        loading: true,
      };
    case PORTAL_NET_INVENTORY_POPUP_SUCCESS:
      return {
        ...state,
        loading: false,
        portalNetInventPopup: action.payload,
      };
    case PORTAL_NET_INVENTORY_POPUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Run Cron Function Reducers Reducers
export const RunCronFunctionReducers = (
  state = { RunCronFunc: {} },
  action
) => {
  switch (action.type) {
    case SYNC_CRON_FUNCTION_REQUEST:
      return {
        loading: true,
      };
    case SYNC_CRON_FUNCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        RunCronFunc: action.payload,
      };
    case SYNC_CRON_FUNCTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
